<div style="max-height:600px; overflow:scroll; overflow-scrolling: auto;">      <div *ngIf="spannedHtml" [innerHTML]="spannedHtml"></div>    </div>